export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/social_media_marketing.584e062.svg";